import { API_URL } from "../config"
import { OrgEntity } from "../types/org"

export const uniq = (array: any[]) => Array.from(new Set(array.filter(Boolean)))

export const getBikeUuidFromUrl = (url: string) => {
  const [, uuid] = url.match(/api\/bicycles\/(.*)\//) || []
  return uuid
}

export const getLockUuidFromUrl = (url: string) => {
  const [, uuid] = url.match(/api\/locks\/(.*)\//) || []
  return uuid
}

export const getOrgUuidFromUrl = (url: string) => {
  const [, uuid] = url.match(/api\/organizations\/(.*)\//) || []
  return uuid
}

export const getOrgUrlFromUuid = (uuid: string) => {
  return `${API_URL}organizations/${uuid}/`
}

export const getAxaLockUuidFromUrl = (url: string) => {
  const [, uuid] = url.match(/api\/axa_locks\/(.*)\//) || []
  return uuid
}

export const hierarchySorter = (orgs: OrgEntity[]) => {
  const res: OrgEntity[] = []
  let tempRes: OrgEntity[] = []
  let toSort: OrgEntity[] = []

  toSort = orgs.filter((org) => {
    if (!org.parent || !orgs.find((e) => e.uuid === org.parent)) {
      org.hierarchyLevel = 0
      res.push(org)
      return undefined
    } else return org
  })
  if (toSort.length === 0) return res.reverse()

  const levelFilter = (org: OrgEntity, level: number): OrgEntity | undefined => {
    const parentIdx = tempRes.findIndex((e) => e.uuid === org.parent)
    if (parentIdx >= 0) {
      org.hierarchyLevel = level
      res.splice(parentIdx, 0, org)
      return undefined
    } else return org
  }

  tempRes = JSON.parse(JSON.stringify(res))
  toSort = toSort.filter((org) => levelFilter(org, 1))
  if (toSort.length === 0) return res.reverse()

  tempRes = JSON.parse(JSON.stringify(res))
  toSort = toSort.filter((org) => levelFilter(org, 2))
  if (toSort.length === 0) return res.reverse()

  tempRes = JSON.parse(JSON.stringify(res))
  toSort = toSort.filter((org) => levelFilter(org, 3))

  return res.reverse()
}

export const getVersion = (version: string): number[] | undefined => {
  let res: number[] = []
  try {
    res = version.split(".").map((e) => parseInt(e))
  } catch {}
  if (res.length === 3) return res
  else return undefined
}
